import {HttpClient} from "@angular/common/http";
import {Page} from "../model/core/page.model";
import {Pageable} from "../model/core/pageable.model";
import {UrlBuilder} from "./url.builder";
import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class BackendServiceUtils {

    constructor(private httpClient: HttpClient) { }

    public findAll<T>(urlBuilder: UrlBuilder, elementsPerPage?:number):Promise<T[]> {
        let allValues:T[] = [];
        let page:number = 0;
        let size = elementsPerPage ? elementsPerPage : 10;
        return new Promise<T[]>((resolve, reject) => {
            this.findAllPages(urlBuilder, page, size, allValues, resolve, reject);
        })
    }

    private findAllPages<T>(urlBuilder: UrlBuilder, page: number, size: number, allValues: T[], resolve: (value?: (PromiseLike<T[]> | T[])) => void, reject: (reason?: any) => void) {
        let url = urlBuilder.withPagination(Pageable.of(page, size)).build();
        this.findByPage(url, allValues)
            .then(end => end ? resolve(allValues) : this.findAllPages(urlBuilder, page + 1, size, allValues, resolve, reject))
            .catch((e) => reject(e));
    }


    private findByPage<T>(url: string, allValues:T[]):Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpClient
                .get<Page<T>>(url)
                .toPromise()
                .then(pagedLovValues => {
                    pagedLovValues.content.forEach(value => allValues.push(value));
                    resolve(pagedLovValues.last);
                })
                .catch((e) => reject(e));
        })
    }
}
